import * as types from './actionTypes';  
import createAllocationApi from '../api/createAllocationApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doCreateAllocation(request) {

  return {
    type: types.DO_CREATE_ALLOCATION, 
    request
  };
}

export function doCreateAllocationRes(data) {  
  return {
    type: types.DO_CREATE_ALLOCATION_RES, 
    data
  };
}

export function submitCreateAllocation(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      createAllocationApi.doCreateAllocation(request).then(data => {
        dispatch(doCreateAllocationRes(data));
        dispatch(doCreateAllocationRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}